module.exports = __webpack_public_path__ + "static/media/blocker_reposition.b833d8dd.png";